var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRBall3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 54,
    viewBox: "0 0 61 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3a1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2d29e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10418",
    "data-name": "Group 10418",
    transform: "translate(-1361 -438)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "translate(1373 443)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(1361 438)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRBall3);
export default __webpack_public_path__ + "static/media/r-ball3.284da95c8a12515b7fee95b71166acdc.svg";
export { ForwardRef as ReactComponent };